import Vue from 'vue'

const store = Vue.observable({
    projectSettings: {
        audioItems: []
    }
});
  
export default store